import { jsx as _jsx } from "react/jsx-runtime";
import { LazyLoadOptions, } from '@as-react/common-types';
import { Box } from '@as/cotopaxi';
import { SingleProductTileDescription } from './SingleProductTileDescription';
import { ProductTileVertical, } from '../../components/product-tile/vertical/ProductTileVertical';
import { useAemConfig } from '@as-react/common-components';
const SingleProductTile = ({ analyticsBannerId, product, tileFormat, deliveryPromiseExplanations, withoutSpacing = false, onWishListToggle, updateCompareList, getDeliveryPromise, addToBasket, isFallbackProduct, shortDescription, pros, cons, adjustTileDescriptionHeight, }) => {
    const { feature_toggles: { lowest_price_all }, } = useAemConfig();
    const boxSpacing = !withoutSpacing
        ? {
            mobile: {
                spacing: {
                    paddingLeft: 1,
                    paddingRight: 1,
                },
            },
            tablet: {
                spacing: {
                    paddingLeft: 1.5,
                    paddingRight: 1.5,
                },
            },
            desktop: {
                spacing: {
                    paddingLeft: 2,
                    paddingRight: 2,
                },
            },
        }
        : {};
    const showDescription = tileFormat === 'simple' && !isFallbackProduct && Boolean(shortDescription || (pros === null || pros === void 0 ? void 0 : pros.length) || (cons === null || cons === void 0 ? void 0 : cons.length));
    return (_jsx(Box, Object.assign({}, boxSpacing, { dataAttributes: { 'data-analytics-bannerid': analyticsBannerId }, fullHeight: adjustTileDescriptionHeight, children: _jsx(ProductTileVertical, { product: product, format: tileFormat, deliveryPromiseExplanations: deliveryPromiseExplanations, onWishListToggle: onWishListToggle, updateCompareList: updateCompareList, getDeliveryPromise: getDeliveryPromise, addToBasket: addToBasket, shouldLazyLoadImage: LazyLoadOptions.LAZY_LOAD, dropdownProps: { appendToBody: true }, showProductOutOfStockOverlay: true, showColorOutOfStockOverlay: true, adjustDescriptionHeight: adjustTileDescriptionHeight, description: showDescription && _jsx(SingleProductTileDescription, { description: shortDescription, pros: pros, cons: cons }), enablePriceReference: lowest_price_all }) })));
};
export default SingleProductTile;
